export const splitArrayOnParts = (array, itemsInOnePart = 8) =>
    array.reduce((acc, cur, idx) => {
        if (idx % itemsInOnePart === 0) {
            acc.push([cur]);
        } else {
            acc[acc.length - 1].push(cur);
        }
        return acc;
    }, []);
